import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ContactForm from "../ContactForm/ContactForm";
import { useTheme } from "../Theming/ThemingProvider";

const Footer = () => {
  const { t } = useTranslation(["contact"]);
  const { theme } = useTheme();
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <>
      <div className="footer-frame">
        <footer className="footer">
          <span className="footer-copyright">
            Copyright © {new Date().getFullYear()} Health Profile
          </span>
          <button
            className="contact-button"
            onClick={() => setContactOpen(true)}
          >
            <FontAwesomeIcon icon={faEnvelope} />
            {" " + t("contact_us")}
          </button>
        </footer>
      </div>
      <ContactForm
        primaryColor={theme.primaryColor}
        open={contactOpen}
        toggle={() => setContactOpen(false)}
      />
    </>
  );
};

export default Footer;
